module.exports = __webpack_public_path__ + "static/media/IGO.1956793f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/IGO.jpg
// module id = 1754
// module chunks = 1